<template>
    <div :style="{'height' : theTableHeight +'px' }">
        <div class="simple-form flex col-4 label">
            <div class="form-group center">
                <div class="form-label">
                    <label>订单编号</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.no }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>商家</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.sellerName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>交付状态</label>
                </div>
                <div class="form-value">
                    <span v-if="goodsOrder.shipState==0"> 商家未发货，联系商家</span>
                    <span v-if="goodsOrder.shipState!=0 && goodsOrder.recvState==0">商家已发货，等待确认收货</span>
                    <span v-if="goodsOrder.shipState!=0 && goodsOrder.recvState==1">已部分收货</span>
                    <span v-if="goodsOrder.shipState!=0 && goodsOrder.recvState==2">已收货</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>订单状态</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.state }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="goodsOrder.cancelled">
                <div class="form-label">
                    <label>取消原因</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.cancelCause }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="goodsOrder.postscript != null">
                <div class="form-label">
                    <label>买家附言</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.postscript }} </span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>无需继续发货</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.shipAborted ? '是' : '否' }} </span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否需要签署确认</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.signConfirmNeeded ? '是' : '否' }} </span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否在线签署</label>
                </div>
                <div class="form-value">
                    <span>{{ goodsOrder.onlineSignFlag ? '是' : '否' }} </span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>签署状态</label>
                </div>
                <div class="form-value">
                    <span>{{ signStatusMap[goodsOrder.signStatus] }} </span>
                </div>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :pageNoChangeHandler="handlePageChange" :tableHeight="tableHeight" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>

import { Utils, $ } from '../../app.base'
import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
//
import goodsOrderApi from '../../api/goodsOrder'

export default {
    name: 'swb-goods-order-info',
    desc: '商品订单详情',
    props: ['goodsOrderId', 'theTableHeight'],
    data: function () {
        return {
            goodsOrder: {},
            confKey: 'swb-goods-order-info',
            queryOnLoad: true,
            //
            needPager: false, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: true, //行号列是否固定（默认：false）
            signStatusMap: getEnumMap('goodsOrderEsignState', 'value2text')
        }
    },
    created: function () {
        /* let goodsOrderId = this.$route.query.goodsOrderId || null;*/
        this.getGoodsOrderById(this.goodsOrderId);
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //根据新主元素的内容大小，调整表格高度
            self.tableHeight = height;

        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.simple-form'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if(domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'taxRate': function (row, colName, colValue, rowIndex, colConf) {
                    return row.taxRate || 0.00;
                },
                'taxAmount': function (row, colName, colValue, rowIndex, colConf) {
                    // 税额=含税金额/（1+税率）*税率
                    if(Utils.isNoB(row.taxRate)) {
                        return 0.00;
                    } else {
                        return ((row.price * row.quantity || 0) / (1 + (row.taxRate * 0.01)) * (row.taxRate * 0.01)).toFixed(2) || 0.00;
                    }
                },
                'skuDefaultImageUrl': function (row, colName, colValue, rowIndex, colConf) {
                    if(!Utils.isNoB(row.imageUrl)) {
                        return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.skuDefaultImageUrl + '"/></a>';
                    } else {
                        return '';
                    }
                },
                'discountTotal': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + ((parseFloat((row.amount - row.discount) || 0).toFixed(2))) + '</span>';
                }

            }, /* 单元格按钮点击处理函数 */ {});
        },
        renderTable(rows, pagination) {
            let resultTable = this.$refs.result_table;
            let tableData = {
                rows: rows,
                pagination: pagination
            };
            resultTable.render(tableData);
        },
        // 单元格点击事件
        rowDblClickHandler: function (row) {
            if(!this.multiSelect) {
                console.log('----- 双击数据行 ----');
                console.log(row);
            }
        },

        getGoodsOrderById: function (goodsOrderId) {
            let self = this;
            let postData = {};
            postData.id = goodsOrderId;
            //
            let msgBoxDlg = MsgBox.loading();
            goodsOrderApi.getGoodsOrderInfo(postData, function (result) {
                msgBoxDlg.close();
                if(result.type == 'info') {
                    self.goodsOrder = result.data;
                    let goodsOrder = self.goodsOrder;
                    let goodsOrderItemlist = goodsOrder.itemList;

                    self.renderTable(goodsOrderItemlist);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsOrderInfo.vue